import { DependenciesInjection } from "app/di/DependencyInjection";
import { VnSkyOscLookupImpl } from "../data/VnSkyOscLookupImpl";
import { IVnSkyOscLookupRepository } from "../domain/repositories/IVnSkyOscLookupRepository";
import { VnSkyOscLookupUseCase } from "../domain/useCases/VnSkyOscLookupUseCase";
import { VnskySupportOcsInfoViewModel } from "../presentation/viewModel/VnskySupportOcsInfoViewModel";
import { VnskySupportOcsInfoToken } from "./VnskySupportOcsInfoToken";

export class VnskySupportOcsInfoInjection {
  static initInjections() {
    DependenciesInjection.register<VnskySupportOcsInfoViewModel>(
      VnskySupportOcsInfoToken.VnskySupportOcsInfoViewModel,
      VnskySupportOcsInfoViewModel,
      "viewModel",
    );
    DependenciesInjection.register<IVnSkyOscLookupRepository>(
      VnskySupportOcsInfoToken.IVnSkyOscLookupRepository,
      VnSkyOscLookupImpl,
      "otherRepo",
    );
    DependenciesInjection.register<VnSkyOscLookupUseCase>(
      VnskySupportOcsInfoToken.VnSkyOscLookupUseCase,
      VnSkyOscLookupUseCase,
      "otherRepo",
    );
  }

  static getRepo() {
    return DependenciesInjection.getRepo<IVnSkyOscLookupRepository>(
      VnskySupportOcsInfoToken.IVnSkyOscLookupRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<VnSkyOscLookupUseCase>(
      VnskySupportOcsInfoToken.VnSkyOscLookupUseCase,
    );
  }
}
